import {
    type ApiResult,
    type BaseParams,
    type CompetitionCollection,
    type EsCollection,
    links,
    Request,
} from '@app/client';

import { apiReturnResults } from '../../ApiFactory';

export async function listCollections(params: BaseParams): Promise<ApiResult<CompetitionCollection[]>> {
    return Request.getRequest<CompetitionCollection[]>({
        ...params,
        target: links.competitions.collections(),
    });
}

export async function getCollectionsMetadata(
    params: BaseParams & { searchQuery: string },
): Promise<ApiResult<EsCollection[]>> {
    return Request.getRequest<EsCollection[]>({
        ...params,
        apiSettingsType: 'gs',
        target: links.globalSearch().collectionsBySlug(params.searchQuery),
    });
}

export const callGetCollectionsMetadata = (params: BaseParams & { searchQuery: string }) =>
    apiReturnResults<EsCollection[]>(getCollectionsMetadata, params);

export const callGetCompetitionsCollections = (params: BaseParams) =>
    apiReturnResults<CompetitionCollection[]>(listCollections, params);
